import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import firebase from 'firebase'
import 'materialize-css/dist/js/materialize.min'

Vue.config.productionTip = false

// Your web app's Firebase configuration
var config = {
  apiKey: "AIzaSyAhCimUtS_nxCGJKKyWmsCGy3ZcJlPjFSg",
  authDomain: "glmtscatt.firebaseapp.com",
  databaseURL: "https://glmtscatt.firebaseio.com",
  projectId: "glmtscatt",
  storageBucket: "glmtscatt.appspot.com",
  messagingSenderId: "380418074339",
  appId: "1:380418074339:web:7357a27e6f05caf48e87d6",
  measurementId: "G-SYT5FJ3RS1"
};
// Initialize Firebase
firebase.initializeApp(config);

let app = '';

firebase.auth().onAuthStateChanged(()=>{

  if(!app){
    app = new Vue({
      router,
      render:h => h(App)
    }).$mount('#app');
  }
  
});


// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app')
